/* ─────────────────────────────────────────
   NEON SKIES COLLECTABLES — THEME JS
   ───────────────────────────────────────── */

'use strict';

/* ── CAROUSEL ── */
function scrollCar(id, dir) {
  var c = document.getElementById(id);
  if (!c) return;
  var firstChild = c.firstElementChild;
  var cardW = firstChild ? firstChild.offsetWidth + 16 : 210;
  c.scrollBy({ left: dir * cardW * 2, behavior: 'smooth' });
}

/* ── NAV HAMBURGER ── */
function toggleNav(btn) {
  var nl = document.getElementById('nav-links');
  if (!nl) return;
  var isOpen = nl.classList.toggle('open');
  if (btn) {
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    btn.textContent = isOpen ? '✕' : '☰';
  }
  // Close any open dd when closing nav
  if (!isOpen) {
    document.querySelectorAll('.nav-links li.dd-open').forEach(function(li) {
      li.classList.remove('dd-open');
    });
  }
}

/* ── MOBILE DROPDOWN TOGGLE ── */
document.querySelectorAll('.nav-links > li > a').forEach(function(a) {
  a.addEventListener('click', function(e) {
    var nl = document.getElementById('nav-links');
    if (!nl || !nl.classList.contains('open')) return;
    var li = this.closest('li');
    var dd = li.querySelector('.dd');
    if (!dd) return;
    e.preventDefault();
    li.classList.toggle('dd-open');
  });
});

/* ── BOOKING FORM TOGGLE ── */
function toggleBooking() {
  var exp = document.getElementById('bk-expanded');
  var btn = document.getElementById('bk-toggle');
  if (!exp || !btn) return;
  var isOpen = exp.style.display === 'block';
  exp.style.display = isOpen ? 'none' : 'block';
  btn.textContent = isOpen ? 'Book Now' : 'Close';
  btn.className = isOpen ? 'btn btn-y' : 'btn btn-o';
  btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  if (!isOpen) {
    setTimeout(function() {
      exp.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 50);
  }
}

/* ── SELL TABS ── */
function switchTab(t, btn) {
  document.querySelectorAll('.spane').forEach(function(p) { p.classList.remove('act'); });
  document.querySelectorAll('.stab').forEach(function(b) {
    b.classList.remove('act');
    b.setAttribute('aria-selected', 'false');
  });
  var pane = document.getElementById('sp-' + t);
  if (pane) pane.classList.add('act');
  btn.classList.add('act');
  btn.setAttribute('aria-selected', 'true');
}

/* ── FILE UPLOAD DISPLAY ── */
function handleFiles(input, listId) {
  var list = document.getElementById(listId);
  if (!list) return;
  list.innerHTML = '';
  Array.from(input.files).forEach(function(f) {
    var item = document.createElement('div');
    item.className = 'fli';
    var name = document.createElement('span');
    name.textContent = f.name;
    var rm = document.createElement('button');
    rm.className = 'frm';
    rm.type = 'button';
    rm.setAttribute('aria-label', 'Remove ' + f.name);
    rm.textContent = '×';
    rm.addEventListener('click', function() { item.remove(); });
    item.appendChild(name);
    item.appendChild(rm);
    list.appendChild(item);
  });
}

/* ── SELL FORM SUBMIT (native fallback — Shopify contact form handles real submission) ── */
function submitSellForm(id) {
  var body = document.getElementById(id + '-body');
  var msg = document.getElementById('sm-' + id);
  if (!body || !msg) return;
  // In production, wire this to a Shopify contact form or Tally embed.
  // This visual feedback is for demo/preview only.
  body.style.display = 'none';
  msg.style.display = 'block';
  msg.focus();
}

/* ── BOOKING FORM SUBMIT (native fallback) ── */
function submitBookingForm(e) {
  e.preventDefault();
  var body = document.getElementById('bk-body');
  var msg = document.getElementById('sm-bk');
  if (!body || !msg) return;
  body.style.display = 'none';
  msg.style.display = 'block';
  msg.focus();
}

/* ── CART — ADD TO CART (AJAX) ── */
function addToCart(e, variantId) {
  e.stopPropagation();
  e.preventDefault();
  var btn = e.currentTarget;
  btn.disabled = true;
  btn.textContent = '…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    btn.textContent = '✓';
    btn.style.background = '#6700C2';
    btn.style.color = '#fff';
    updateCartCount();
    setTimeout(function() {
      btn.textContent = '+';
      btn.style.background = '';
      btn.style.color = '';
      btn.disabled = false;
    }, 1800);
  })
  .catch(function() {
    btn.textContent = '!';
    btn.disabled = false;
    setTimeout(function() { btn.textContent = '+'; }, 1500);
  });
}

/* ── UPDATE CART COUNT IN NAV ── */
function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var cartEl = document.querySelector('.nav-cart');
      if (cartEl) {
        cartEl.textContent = '🛒 Cart (' + cart.item_count + ')';
      }
    });
}

/* ── PARALLAX ── */
(function() {
  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        var scrollY = window.scrollY;
        var art = document.querySelector('.hero-art');
        if (art) art.style.transform = 'translateY(' + (scrollY * 0.32) + 'px)';
        var logo = document.querySelector('.hero-logo-wrap');
        if (logo) logo.style.transform = 'translateY(' + (scrollY * 0.14) + 'px)';
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

/* ── SCROLL REVEAL ── */
(function() {
  function checkReveals() {
    document.querySelectorAll('.reveal:not(.visible)').forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight - 60) {
        el.classList.add('visible');
      }
    });
  }
  window.addEventListener('scroll', checkReveals, { passive: true });
  window.addEventListener('load', checkReveals);
  // Initial check after paint
  requestAnimationFrame(checkReveals);
})();

/* ── FILTER PILLS (collection pages) ── */
document.querySelectorAll('.filter-bar .fpill').forEach(function(pill) {
  // pills that are <a> tags navigate, others toggle class only
  if (pill.tagName !== 'A') {
    pill.addEventListener('click', function() {
      var bar = this.closest('.filter-bar');
      bar.querySelectorAll('.fpill').forEach(function(p) { p.classList.remove('act'); });
      this.classList.add('act');
    });
  }
});

/* ── PRODUCT PAGE: quantity +/- ── */
window.changeQty = function(delta) {
  var input = document.getElementById('qty-input');
  if (!input) return;
  input.value = Math.max(1, parseInt(input.value || 1) + delta);
};

/* ── IMAGE GALLERY (product page) ── */
window.swapImage = function(url) {
  var main = document.getElementById('product-main-image');
  if (main) main.src = url;
};

/* ── TALLY EMBED INIT (if Tally is used for booking) ── */
(function() {
  if (typeof Tally !== 'undefined') {
    Tally.loadEmbeds();
  }
})();

/* ── EXPANDING SEARCH ── */
function toggleSearch(btn) {
  var form  = document.getElementById('nav-search-form');
  var input = document.getElementById('nav-search-input');
  if (!form) return;
  var isOpen = form.classList.toggle('open');
  btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  btn.setAttribute('aria-label', isOpen ? 'Close search' : 'Open search');
  if (isOpen) {
    // swap to close icon
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    setTimeout(function() { if (input) input.focus(); }, 50);
    form.setAttribute('aria-hidden', 'false');
  } else {
    // swap back to search icon
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
    form.setAttribute('aria-hidden', 'true');
  }
}

/* Close search when clicking outside */
document.addEventListener('click', function(e) {
  var wrap = document.getElementById('nav-search-wrap');
  var form = document.getElementById('nav-search-form');
  var btn  = document.getElementById('nav-search-btn');
  if (!wrap || !form) return;
  // toggleSearch swaps the button icon, detaching the clicked svg. A detached
  // target fails wrap.contains() and instantly re-closed the form, so bail.
  if (e.target && e.target.isConnected === false) return;
  if (!wrap.contains(e.target) && form.classList.contains('open')) {
    form.classList.remove('open');
    form.setAttribute('aria-hidden', 'true');
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Open search');
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
    }
  }
});

/* ── BLUEPRINT GRID PHASE-LOCK ──
   The section textures (theme-sections.css) tile a 96px blueprint grid.
   Each textured section restarts its grid at its own top edge, so two
   textured sections meeting mid-page would show a visible seam. This
   sets --bp-y per element to shift its grid so every line lands on the
   page-wide 96px rhythm. Fixed-position elements (nav, dialogs) are
   skipped: they move with the viewport, not the page. */
(function() {
  function lockGrid() {
    document.querySelectorAll('.sec-tex, .bg-alt, .purple-tex, .sell-page-bg').forEach(function(el) {
      if (getComputedStyle(el).position === 'fixed') return;
      var top = el.getBoundingClientRect().top + window.scrollY;
      var shift = ((top % 96) + 96) % 96;
      el.style.setProperty('--bp-y', (-shift) + 'px');
    });
  }
  window.addEventListener('load', lockGrid);
  window.addEventListener('resize', lockGrid);
  requestAnimationFrame(lockGrid);
})();
